const medicalGuideFields = [
  {
    name: 'ans_register',
    type: 'text',
    placeholder: 'Registro na ANS',
    maxlength: 6,
    category: null,
    readonly: false,
    value: null
  },
  {
    name: 'authorization_number',
    type: 'text',
    placeholder: 'Número da guia',
    maxlength: 15,
    category: null,
    readonly: false,
    value: null
  },
  {
    name: 'guide_number_assigned_operator',
    type: 'text',
    placeholder: 'Número da guia na operadora',
    maxlength: 15,
    category: null,
    readonly: false,
    value: null
  },
  {
    name: 'special_patient_health_insurance_wallet_number',
    type: 'text',
    placeholder: 'Número do carteira',
    category: 'Dados do beneficiário',
    readonly: true,
    value: null
  },
  {
    name: 'special_patient_health_insurance_wallet_validity',
    type: 'date',
    placeholder: 'Validade da carteira',
    category: 'Dados do beneficiário',
    filter: 'MM/YYYY',
    mandatory: false,
    readonly: true,
    value: null
  },
  {
    name: 'newborn_care',
    type: 'radio',
    options: [
      {
        value: true,
        name: 'Sim'
      },
      {
        value: false,
        name: 'Não'
      }
    ],
    placeholder: 'Atendimento a recém-nascido',
    category: 'Dados do beneficiário',
    readonly: false,
    value: null
  },
  {
    name: 'special_patient_name',
    type: 'text',
    placeholder: 'Nome',
    category: 'Dados do beneficiário',
    flex: 2,
    readonly: true,
    value: null
  },
  {
    name: 'special_patient_national_health_card',
    type: 'text',
    placeholder: 'Cartão Nacional de Saúde',
    category: 'Dados do beneficiário',
    readonly: true,
    value: null
  },
  {
    name: 'doctor_office_health_insurance_operator_code',
    type: 'text',
    placeholder: 'Código na operadora', // Pode ser código na operadora, ou o CNPJ, ou o CPF do contratado
    category: 'Dados do contratado',
    maxlength: 14,
    readonly: false,
    value: null
  },
  {
    name: 'doctor_office_name',
    type: 'text',
    placeholder: 'Nome do contratado',
    category: 'Dados do contratado',
    readonly: true,
    value: null
  },
  {
    name: 'cnes_code',
    type: 'text',
    placeholder: 'Código CNES',
    category: 'Dados do contratado',
    maxlength: 7,
    readonly: false,
    value: null
  },
  {
    name: 'doctor_name',
    type: 'text',
    placeholder: 'Nome do executante',
    category: 'Dados do contratado',
    readonly: true,
    value: null
  },
  // {
  //   name: 'crm_type',
  //   type: 'text',
  //   placeholder: 'Conselho',
  //   category: 'Dados do contratado',
  //   flex: '05', // 0.5
  //   readonly: true,
  //   value: 'CRM'
  // },
  {
    name: 'crm',
    type: 'text',
    placeholder: 'Número CRM',
    category: 'Dados do contratado',
    flex: '05', // 0.5
    readonly: true,
    value: null
  },
  {
    name: 'crm_regional',
    type: 'text',
    placeholder: 'UF',
    category: 'Dados do contratado',
    flex: '05', // 0.5
    readonly: true,
    value: null
  },
  {
    name: 'cbos_code',
    type: 'text',
    placeholder: 'Código CBO-S',
    category: 'Dados do contratado',
    flex: '05', // 0.5
    maxlength: 5,
    readonly: false,
    value: null
  },
  {
    name: 'accident_indication',
    type: 'select',
    options: [
      {
        value: 0,
        name: 'Acidente ou doença relacionada a trabalho'
      },
      {
        value: 1,
        name: 'Acidente ou doença relacionada a trânsito'
      },
      {
        value: 2,
        name: 'Outros'
      },
      {
        value: 3,
        name: 'Não acidente'
      }
    ],
    placeholder: 'Indicação de acidente',
    category: 'Dados do atendimento',
    readonly: false,
    value: 3
  },
  {
    name: 'medical_consultation_date',
    type: 'date',
    placeholder: 'Data do atendimento',
    filter: 'DD/MM/YYYY',
    category: 'Dados do atendimento',
    readonly: true,
    value: null
  },
  {
    name: 'medical_consultation_type',
    type: 'select',
    options: [
      {
        value: 1,
        name: 'Primeira consulta'
      },
      {
        value: 2,
        name: 'Retorno'
      },
      {
        value: 3,
        name: 'Pré-natal'
      }
    ],
    placeholder: 'Tipo de consulta',
    category: 'Dados do atendimento',
    readonly: false,
    value: null
  },
  {
    name: 'table_code',
    type: 'text',
    placeholder: 'Código de tabela',
    category: 'Dados do atendimento',
    maxlength: 2,
    readonly: false,
    value: null
  },
  {
    name: 'procedure_code',
    type: 'text',
    placeholder: 'Código do procedimento',
    category: 'Dados do atendimento',
    maxlength: 10,
    readonly: false,
    value: null
  },
  {
    name: 'procedure_value',
    type: 'currency',
    placeholder: 'Valor do procedimento',
    category: 'Dados do atendimento',
    readonly: true,
    value: null
  }
]

export default medicalGuideFields
